import { Injectable } from '@angular/core';
import { Howl, Howler } from 'howler';

@Injectable({
  providedIn: 'root'
})
export class SoundManagerService {
  instancePool: Map<string, Howl> = new Map();

  constructor() { }

  loadSounds(soundsData) {
    Object.entries(soundsData).forEach(([key, value]) => {
      this.instancePool.set(key, new Howl({
        src: value,
        html5: true,
        // loop: (key == 'bgMusic'),
      }));
    });
  }

  playSound(key: string) {
    const sound = this.instancePool.get(key);
    if (sound) {
      sound.play();
    }
  }

  stopSound(key: string) {
    const sound = this.instancePool.get(key);
    if (sound) {
      sound.stop();
    }
  }

  stopAll() {
    this.instancePool.forEach((value) => {
      if (value.playing) {
        value.stop();
      }
    });
  }

  /*
  pauseSound(key: string) {
    const sound = this.instancePool.get(key);
    if (sound && sound.playing()) {
      sound.pause();
    }
  } */

  muteAllSounds() {
    Howler.volume(0);
  }

  unmuteAllSounds() {
    Howler.volume(1);
  }

  clearInstancePool() {
    this.instancePool.forEach((value) => {
      value.unload();
    });
    this.instancePool.clear();
  }
}
